export default "__VITE_ASSET__NrNaBceW__"